import { useState, type ChangeEvent } from "react";
import { useLookupDonsQuery } from "../../stores/OkOkStore";
import type { Dons,DonsParameters } from "../../types/Dons";
import Pager from "../Common/Pager";
import { NavLink } from "react-router";
import { useTrads } from "../../contexts/trads/useTrads";
import FondInfo from "../Common/FondInfo";
import { formatDate, uniqid } from "../../tools/utils";

function DonsList(){
    const [params,setParams]=useState<DonsParameters>({page:0});
    const { data, error, isLoading } = useLookupDonsQuery(params);
    const setPage=function(page:number){
        setParams({...params,page: page})
    }
    const setOrder=function(order:string,reverse?:number){
        setParams({...params,order:order,reverse:reverse ?? 0});
    }
    const changeStatus=function(e:ChangeEvent<HTMLInputElement>){
        const z:string[]=params.r?.statut ? [...params.r.statut]:[];
        if(e.target.checked){
            if(!z.includes(e.target.value)){
                z.push(e.target.value);

            }
        }else{
            const index=z.indexOf(e.target.value);
            if(index>=0){
                z.splice(index, 1);

            }
        }
        setParams(
            {...params,
                   r:{...params.r,statut:z}
            }
        );
    }
    const statusList = ['00_draft','05_paye','02_refused'];

    const statusClass=function(e:string):string{
        if(e=='00_draft'){
            return "table-primary";
        }
        if(e=='05_paye'){
            return "table-success"
        }

        if(e=='02_refused'){
            return "table-danger"
        }

        return "table-dark"
    }



    const {translate}=useTrads();
    

        return (
 
            error ? (
                <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p>

            ) : isLoading ? (
                <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p>
            ) : data ? (
                <>
                <div className="d-flex flex-wrap mr-3">
                    {statusList.map((item)=>{
                        const id=uniqid();
                        return (
                            <div  className="form-check form-switch"  key={id}>
                                <input id={id} className="form-check-input"  type="checkbox" value={item} onChange={changeStatus} checked={params.r?.statut?.includes(item)} /> 
                                <label htmlFor={id} className="form-check-label">  {translate(item)}  </label>
                        
                            </div>
                        )}
                    )}
                </div>


                <Pager curpage={data.page} totalpages={data.pages} setter={setPage}></Pager>
                <table className="table table-hover">
                    <thead className="sticky-top">
                        <tr>
                            <th data-sort="id">
                                <div className="table-sort">
                                    {translate('id')}
                                    <div className={(params.order=='id')?((params.reverse)?'desc':'asc'):undefined}>
                                        <a className='up' onClick={()=>{setOrder('id',1)}} ><i className="bi"></i></a>
                                        <a className='down' onClick={()=>{setOrder('id',0)}} ><i className="bi"></i></a>
                                    </div>
                                </div>
                            </th>
                             <th data-sort="montant">
                                <div className="table-sort">
                                    {translate('montant')}
                                    <div className={(params.order=='montant')?((params.reverse)?'desc':'asc'):undefined}>
                                        <a className='up' onClick={()=>{setOrder('montant',1)}} ><i className="bi"></i></a>
                                        <a className='down' onClick={()=>{setOrder('montant',0)}} ><i className="bi"></i></a>
                                    </div>
                                </div>
                            </th>
                            <th data-sort="statut">

                                <div className="table-sort">
                                    {translate('statut')}
                                    <div className={(params.order=='statut')?((params.reverse)?'desc':'asc'):undefined}>
                                        <a className='up' onClick={()=>{setOrder('statut',1)}} ><i className="bi"></i></a>
                                        <a className='down' onClick={()=>{setOrder('statut',0)}} ><i className="bi"></i></a>
                                    </div>
                                </div>


                            </th>
                            <th>{translate('dons_nom')}</th>
                            <th>{translate('dons_prenom')}</th>
                            <th>{translate('dons_registre')}</th>
                            <th  data-sort="creation">


                                <div className="table-sort">
                                    {translate('creation')}
                                    <div className={(params.order=='creation')?((params.reverse)?'desc':'asc'):undefined}>
                                        <a className='up' onClick={()=>{setOrder('creation',1)}} ><i className="bi"></i></a>
                                        <a className='down' onClick={()=>{setOrder('creation',0)}} ><i className="bi"></i></a>
                                    </div>
                                </div>



                            </th>
                            <th></th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {data.data.map((don:Dons) => (
                            <tr key={don.id}>
                                <td>{don.id}</td>
                                <td>{don.montant}</td>
                                <td className={statusClass(don.statut)}>{translate(don.statut)}</td>
                                <td>{don.nom}</td>
                                <td>{don.prenom}</td>
                                <td>{don.registre}</td>
                                <td>{formatDate(don.creation)}</td>
                                <td><NavLink to={`/fond/${don.fond_id.toString()}`}><FondInfo fondId={don.fond_id} /></NavLink></td>
                                <td>
                                    <NavLink to={`/dons/${don.id.toString()}`}>
                                        <span className="visually-hidden">{translate('btn_voir')}</span>
                                        <i className="bi bi-eye-fill"></i>
                                    </NavLink>
                                </td>

                            </tr>
                        ))}
                    </tbody>
                </table>
                <Pager curpage={data.page} totalpages={data.pages} setter={setPage}></Pager>
                
                </>
            ):null
        );
}
export default DonsList;